module.exports = __webpack_public_path__ + "img/star.7ca239ec.png";